import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Redirect } from 'react-router-dom'
import { connect } from 'react-redux'
import {
  authRestoreLogon,
  authLogin,
  authDismissAlert,
} from 'redux/actions/auth'

import {
  Alert,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from 'reactstrap'

import 'assets/fonts/font-awesome/css/font-awesome.css'
import 'assets/css/login.css'
import AppLogo from 'widgets/elemental/app-logo'
import ButtonLogin from 'widgets/elemental/button-login'
import InputEmail from 'widgets/elemental/input-email'
import InputPassword from 'widgets/elemental/input-password'

const dropdownStyle = {
  width: '100%',
  margin: 'auto',
  textAlign: 'center',
}

const dropdownMenuStyle = {
  width: '50%',
  margin: 'auto',
  textAlign: 'center',
  borderRadius: '25px',
  backgroundColor: '#666666',
  color: '#ffffff',
  border: '0',
}

const dropdownItemStyle = {
  width: '50%',
  margin: 'auto',
  fontSize: '12px',
  textAlign: 'center',
  borderRadius: '15px',
  backgroundColor: '#cccccc',
  overflow: 'overlay',
}

const alertStyle = {
  margin: '15px auto 0px',
  fontSize: '12px',
  textAlign: 'center',
  borderRadius: '15px',
}

class Login extends Component {
  // ------------------------------- life cycle methods ---------------------------
  constructor(props) {
    super(props)
    // console.log(props)
    this.state = {
      email: '',
      password: '',
      dropdownOpen: false,
      roleSelected: 'Officer',
      isHovered: false,
    }
  }

  UNSAFE_componentWillMount() {
    // console.log("Login >", "logon :",);
    const logon = localStorage.getItem('guardexpert_logon')
    if (logon) {
      const authState = JSON.parse(logon)
      if (authState) {
        this.props.dispatch(authRestoreLogon(authState))
      }
    }
  }

  toggle = () => {
    this.setState((prevState) => ({
      dropdownOpen: !prevState.dropdownOpen,
    }))
    if (this.props.auth_showAlert) {
      this.props.dispatch(authDismissAlert())
    }
  }

  onOfficerSelected = () => {
    this.setState({
      roleSelected: 'officer',
    })
  }

  onAdminSelected = () => {
    this.setState({
      roleSelected: 'admin',
    })
  }

  onMarshallSelected = () => {
    this.setState({
      roleSelected: 'marshal',
    })
  }

  onSystemSelected = () => {
    this.setState({
      roleSelected: 'system',
    })
  }

  // ----------------------------- required ------------------------------------
  render() {
    const currentOrigin = window.location.origin
    const attendanceUrl = new URL(currentOrigin)
    attendanceUrl.hostname = 'hadir.' + attendanceUrl.hostname
    const attendanceBaseUrl = attendanceUrl.toString()

    const { auth_isAuth: authIsAuth } = this.props
    if (authIsAuth) {
      console.log('Redirecting ...')
      return <Redirect to="/" />
    }
    return (
      <div>
        <div className="login-container">
          <div className="login-wrapper logo-wrapper">
            <AppLogo />
          </div>
          <div className="login-wrapper form-wrapper">
            <form className="login-form">
              <div className="login-wrap-input">
                <InputEmail
                  email={this.state.email}
                  onEmailChange={this.handleEmailChange}
                />
              </div>
              <div className="login-wrap-input">
                <InputPassword
                  password={this.state.password}
                  onPasswordChange={this.handlePasswordChange}
                />
              </div>
              <div style={dropdownStyle}>
                <Dropdown
                  isOpen={this.state.dropdownOpen}
                  toggle={this.toggle}
                  size="sm"
                  direction={'down'}
                >
                  <DropdownToggle caret style={dropdownMenuStyle}>
                    {this.state.roleSelected}
                  </DropdownToggle>
                  <DropdownMenu right={true} style={dropdownItemStyle}>
                    <DropdownItem onClick={this.onOfficerSelected}>
                      {' '}
                      Officer{' '}
                    </DropdownItem>
                    <DropdownItem onClick={this.onAdminSelected}>
                      {' '}
                      Admin{' '}
                    </DropdownItem>
                    <DropdownItem onClick={this.onMarshallSelected}>
                      {' '}
                      Marshal{' '}
                    </DropdownItem>
                    <DropdownItem onClick={this.onSystemSelected}>
                      {' '}
                      System{' '}
                    </DropdownItem>
                  </DropdownMenu>
                </Dropdown>
              </div>
              {this.props.auth_error && (
                <Alert
                  color="danger"
                  isOpen={this.props.auth_showAlert}
                  style={alertStyle}
                >
                  <strong>
                    {' '}
                    {this.props.auth_error + ':' + this.props.auth_message}{' '}
                  </strong>{' '}
                </Alert>
              )}
              <ButtonLogin onButtonClick={this.handleSubmit} />
              <div
                style={{
                  display: 'flex',
                }}
              >
                <a
                  href={attendanceBaseUrl}
                  rel="noopener noreferrer"
                  style={{
                    color: this.state.isHovered ? '#ea5a5a' : 'white', // red on hover, green otherwise
                    textDecoration: 'none',
                    marginLeft: 'auto',
                    marginTop: '5px',
                    marginRight: '5px',
                  }}
                  onMouseEnter={() => this.setState({ isHovered: true })}
                  onMouseLeave={() => this.setState({ isHovered: false })}
                >
                  Go To Attendance
                </a>
              </div>
            </form>
          </div>
        </div>
      </div>
    )
  }

  // ----------------------------- utilities ------------------------------------
  handleSubmit = (e) => {
    e.preventDefault()
    this.props.dispatch(
      authLogin(this.state.email, this.state.password, this.state.roleSelected)
    )
  }

  handleEmailChange = (e) => {
    if (this.props.auth_showAlert) {
      this.props.dispatch(authDismissAlert())
    }
    this.setState({ email: e })
  }

  handlePasswordChange = (e) => {
    if (this.props.auth_showAlert) {
      this.props.dispatch(authDismissAlert())
    }
    this.setState({ password: e })
  }
}

const mapStateToProps = (store) => {
  return {
    auth_error: store.auth.error,
    auth_message: store.auth.message,
    auth_status: store.auth.status,
    auth_isAuth: store.auth.isAuth,
    auth_showAlert: store.auth.showAlert,
  }
}

Login.propTypes = {
  dispatch: PropTypes.func,
  history: PropTypes.object,
  auth_error: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  auth_message: PropTypes.string,
  auth_status: PropTypes.string,
  auth_isAuth: PropTypes.bool,
  auth_showAlert: PropTypes.bool,
}

export default connect(mapStateToProps)(Login)
